export const noddiColors = {
  darkPurple: '#35155A',
  darkPurple90: '#492C6B',
  darkPurple80: '#5D447B',
  darkPurple70: '#725B8B',
  darkPurple60: '#86739C',
  darkPurple50: '#9A8AAC',
  darkPurple40: '#D7D0DE',
  darkPurple30: '#EBE8EE',

  purple: '#8661C1',
  purple90: '#6D48A7',
  purple80: '#532E8E',
  purple70: '#3A1575',
  purple60: '#20005B',
  purple50: '#070042',
  purple40: '#000028',
  purple30: '#00000F',

  pink: '#FFC7ED',
  pink90: '#FFCDEF',
  pink80: '#FFD2F1',
  pink70: '#FFD8F2',
  pink60: '#FFDDF4',
  pink50: '#FFE3F6',
  pink40: '#FFE9F8',
  pink30: '#FFEEFA',

  orange: '#FF4521',

  white: '#FFFFFF',
  white60: 'rgba(255, 255, 255, 0.6)',
  black: '#000000',
  black10: '#1F1F1F',
  silverGray: '#DADDE0',
  lightPurple: '#EDE5FD',

  raspberry: '#C738BD',
  raspberry90: '#CD4CC4',
  raspberry80: '#D260CA',
  raspberry70: '#D874D1',
  raspberry60: '#DD88D7',
  raspberry50: '#E39BDE',
  raspberry40: '#E9AFE5',
  raspberry30: '#EEC3EB',

  coral: '#FFEAE5',
  coral90: '#FFECE8',
  coral80: '#FFEEEA',
  coral70: '#FFF0ED',
  coral60: '#FFF2EF',
  coral50: '#FFF5F2',
  coral40: '#FFF7F5',
  coral30: '#FFF9F7',

  orange50: '#BB3018',

  grey: '#7C7B7D',
  snow: '#FFFAFA',
  greyMuted: '#717182',

  // Don't use this one
  purpleBg: '#F3EFF9',

  darkPurpleGrey: '#F7F6FA',
  darkPurpleBg: '#F7F7F7',
  raspberryBg: '#F9EBF8',
  darkRaspberry: '#ECDEFB',
  pinkBg: '#FFF4FB',

  outlineStroke: '#EDEEEF',
  transparent: 'transparent',
  success: '#128667',
  success50: '#A0CFC2',
  success20: '#D0E8E2',

  warning: '#D78E01',
  warning50: '#FFFADE',

  danger: '#EA5147',
  danger50: '#FBDCDA'
} as const;
